export const projects = [
  {
    slug: "ledgerline",
    title: "Ledgerline",
    subtitle: "Invoicing and cash-flow dashboard for freelancers",
    type: "Web App",
    year: 2025,
    role: "Lead engineer",
    stack: ["React", "FastAPI", "Postgres"],
    featured: true,
    outcome: "Cut monthly invoicing time from 6 hours to 20 minutes for 1,400 users.",
    image: "https://images.unsplash.com/photo-1527443195645-1133f7f28990?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "northbound",
    title: "Northbound",
    subtitle: "Trip-planning mobile experience for national parks",
    type: "Mobile",
    year: 2025,
    role: "Frontend architect",
    stack: ["React Native", "Mapbox", "Node"],
    featured: true,
    outcome: "4.8 star rating across 22k downloads in the first quarter.",
    image: "https://images.unsplash.com/photo-1695048064952-44b984f2af6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "atlas-cms",
    title: "Atlas CMS",
    subtitle: "Headless content platform for a publishing group",
    type: "Platform",
    year: 2024,
    role: "Full-stack developer",
    stack: ["Next.js", "GraphQL", "Mongo"],
    featured: true,
    outcome: "Editors ship 3x more articles per week with zero developer involvement.",
    image: "https://images.unsplash.com/photo-1604074131228-9d48b811bd80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "quiet-hours",
    title: "Quiet Hours",
    subtitle: "Marketing site and booking flow for a wellness studio",
    type: "Marketing Site",
    year: 2024,
    role: "Designer & developer",
    stack: ["Astro", "Tailwind", "Stripe"],
    featured: false,
    outcome: "Bookings up 62% within two months of launch.",
    image: "https://images.unsplash.com/photo-1499750310159-5b5d61fdd9e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "signalwork",
    title: "Signalwork",
    subtitle: "Internal analytics tooling for a logistics team",
    type: "Web App",
    year: 2023,
    role: "Contract engineer",
    stack: ["Vue", "Python", "ClickHouse"],
    featured: false,
    outcome: "Replaced 14 spreadsheets with one live operations view.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "fieldnote",
    title: "Fieldnote",
    subtitle: "Offline-first note capture for field researchers",
    type: "Mobile",
    year: 2023,
    role: "Solo developer",
    stack: ["Expo", "SQLite", "Sync engine"],
    featured: false,
    outcome: "Worked reliably across 40 sites with no connectivity.",
    image: "https://images.unsplash.com/photo-1516534775068-ba3e7458af70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "grainhouse",
    title: "Grainhouse",
    subtitle: "E-commerce storefront for a small-batch roaster",
    type: "E-commerce",
    year: 2022,
    role: "Developer",
    stack: ["Shopify Hydrogen", "Remix"],
    featured: false,
    outcome: "Page speed score moved from 41 to 98 on mobile.",
    image: "https://images.unsplash.com/photo-1461988320302-91bde64fc8e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "openbench",
    title: "Openbench",
    subtitle: "Open-source component library and docs site",
    type: "Platform",
    year: 2022,
    role: "Maintainer",
    stack: ["TypeScript", "Rollup", "Docusaurus"],
    featured: false,
    outcome: "2.1k GitHub stars and 60+ outside contributors.",
    image: "https://images.unsplash.com/photo-1618477247222-acbdb0e159b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const projectTypes = [...new Set(projects.map((p) => p.type))].sort();
export const projectYears = [...new Set(projects.map((p) => p.year))].sort((a, b) => b - a);
